module.exports = __webpack_public_path__ + "img/img_aiplan_03.28020566.png";